export enum CustomerStatusType {
    All = 1,
    Active = 2,
    OnHold = 3,
    PriceLevelInactive = 4,
}
